import { useExercises } from '@entities/exercise-video';
import { programsApi, useProgram } from '@entities/programs';
import { useEffect, useState } from 'react';
import { xhr } from '@shared/config';
import type { Program } from '@shared/types/programs';
import { usePromoVideos } from '@src/entities/promo-video';

export const useProgramLoader = (id: number) => {
  const [isLoading, setIsLoading] = useState(false);
  const { setProgram } = useProgram(id);
  const { addExercises } = useExercises();
  const { setPromo } = usePromoVideos();

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    const loadProgram = async () => {
      try {
        setIsLoading((prev) => !prev);
        if (!id || isNaN(id)) return;

        const res = await xhr.get<Program>(`${programsApi}${id}/`, { signal });

        if (!res.data) throw res;

        setProgram(res.data);
        if (res.data.promo_video) {
          setPromo(res.data.promo_video);
        }
        addExercises(res.data.videos);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading((prev) => !prev);
      }
    };

    loadProgram();

    return () => {
      controller.abort();
    };
  }, []);

  return {
    isLoading,
  };
};
